<template>
  <sidebar @close="close">
    <template v-slot:head>        
      <div class="container has-text-centered"> 
        <img width="96" height="96" :src="img" />
        <h2 class="title is-4">
          Telegram OTP
        </h2>
      </div>
    </template>
    <template v-slot:body>
      <div class="container has-text-centered" v-if="isConfigured">
        <span>Telegram OTP {{ $t('auth_factors.factor_is_configured') }}</span>
      </div>
      <div class="container has-text-centered" v-else> 
        <div class="field">
          <figure class="avatar">
            <img id="qr" :src="qr" />
          </figure>
        </div>
        <div class="field">
          <a v-if="!!telegram" :href="telegram.link">{{ $t('auth_factors.connect_telegram') }}</a>
        </div>        
      </div>
    </template>
    <template v-slot:foot>
      <div class="container has-text-centered">
        <a @click="unsubscribe" v-if="isConfigured">{{ $t('auth_factors.unsubscribe_telegram') }}</a>
        <a @click="update" v-else>{{ $t('auth_factors.check_telegram') }}</a>  
      </div>
    </template>
  </sidebar>    
</template>

<script>
import tg from "@/services/tg";
import Sidebar from "@/components/Sidebar";
export default {
  name: "TelegramDetails",
  components: {
    Sidebar
  },
  props: {
    telegram: {
      required: true
    },
    img: {
      required: true
    },
    telegram_id: {
      required: true
    }
  },
  data() {
    return {
        passCode: "",
        error: "",
        invalid: false,
        qr: ""
    };
  },
  methods: {
    verify() {
      tg.verifyCode(this.passCode).then(
        () => { 
          this.invalid = false; 
          this.error = "";
          this.close();
        },
        err => {
          this.invalid = true;
          this.error = this.$i18n.t('auth_factors.wrong_code');
          console.log(err);
        }
      );
    },
    sendCode() {
      tg.sendCode().then(() => { 
        },
        err => {
          this.invalid = true;
          this.error = this.$i18n.t('auth_factors.send_code_error');
          console.log(err);
        }
      );
    },
    unsubscribe() {
      tg.unsubscribe().then(
        () => { 
          this.invalid = false;
          this.error = "";
          this.$emit("update", 0);
        },
        err => {
          console.log(err);
          this.close();
        }
      );
    },
    close() {
      this.passCode = "";
      this.error = "";
      this.invalid = false;
      this.$emit("close");
    },
    update() {
      tg.getContact().then(
        resp => {
          this.$emit("update", resp.data.telegramId);
          if (this.isConfigured) {
            this.close();
          }
        },
        err => {
          console.log(err);
        }
      );  
    }
  },
  computed: {
    isConfigured() {
      return typeof this.telegram_id !== 'undefined' && !Number.isNaN(this.telegram_id) && this.telegram_id !== 0
    }
  },
  mounted(){
    tg.getQr().then(r => {
        this.qr = `data:image/png;base64, ${Buffer.from(r.data, 'binary').toString("base64")}`;
    }, err => {
      console.log(err);
    });
  }
};
</script>
